import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import { formatPhoneNumber } from "../utils/formatnumber";
import axios from "axios";

const RegisterNewOrgModal = ({ open, setOpen }) => {
  let organization = null;
  try {
    organization = JSON.parse(localStorage.getItem("organization"));
  } catch (e) {
    organization = null;
  }
  const [loader, setLoader] = useState(false);
  const deleteOrg = async() => {
        setLoader(true);
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user || !organization) return setLoader(false);
     let org = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "delete-organization",
          {
            userId: user.userId.S,
            orgId: organization.orgId.S,
          }
        );

        localStorage.setItem('organization', JSON.stringify(org.data.organizations[0]))
        localStorage.setItem('user', JSON.stringify(org.data.user))
        window.location.pathname = '/dashboard'
        //setLoader(false);
 }

  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    
    
    BackdropProps={{
        style: { backgroundColor: "rgb(144,150,160,0.8)" },
      }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[18px] text-[#030229]  text-[15px] font-bold  text-center mb-4">
            Complete {organization?.organization_name?.S ?? 'Organization'} Setup
        </div>


        <div className="lg:text-[14px] text-[13px] text-center">
      Go ahead to add twilio setup information, add forwarding numbers and create call routes for your new organization.
        </div>


        <div className="flex items-center justify-center space-x-3 mt-4">
        <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'white',
                    color: "#605BFF",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1px solid rgba(96,91,255,0.1)',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> setOpen(false)}
                >
                  Okay
                </Button>


                <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'white',
                    color: "red",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1px solid red',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> deleteOrg()}
                  disabled={!organization}
                >
                  {loader ? 
                  <CircularProgress size={20} color="inherit" />
                   : "Delete Organization"}
                </Button>
                
        </div>


      
      </div>
    </Dialog>
  );
};

export default RegisterNewOrgModal;
